// components/HtmlViewer.jsx
import React from "react";


function HtmlViewer({
  text
}) {
  return (
    <div
      className="html-content"
      dangerouslySetInnerHTML={{ __html: text }}
    />
  );
}

export default HtmlViewer;